package pt.at.oss.kotlin.manual.storage.common.contactinfo

import kotlinx.serialization.Serializable
import pt.lightweightform.kotlin.storage.BaseRecord

/**
 * ContactInfo Serializable object
 *
 * NOTE FOR DEVELOPERS:
 *  - This file was generated. Any modifications to this file will be lost after generation
 * @generated
 */
@Serializable
data class ContactInfo(
    var email: String = "",
    var emailConfirmation: String? = null,
    var telephone: String = ""
) : BaseRecord()
